type FormItemProps = {
    title: string,
    required?: boolean,
    children: any
}

const FormItem = ({ title, required = false, children }: FormItemProps) => {
  return (
    <div className="form-item-wrapper">
      <div className="label-wrapper">
        <label>
            <span>{`${title}:`}</span>
            {required && <span className="required-dot">* </span>}
            </label>
      </div>
      {children}
    </div>
  );
};

export default FormItem;
